import { FC } from "react";
interface BlockPageProps {}

const BlockPage: FC<BlockPageProps> = () => {
  return <div>block page</div>;
};

export default BlockPage;
